const MVCObject = require("../mvcobject").MVCObject;

/**
 * Constructs a new LocationProvider, in order to track browser location
 * @class LocationProvider
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.location
 */
const LocationProvider = function () {
    /**
     * When the LocationProvider returns a result it sets this property.
     * This property is bindable
     * @see woosmap.utils.MVCObject#bindTo
     * @type {LatLngLiteral}
     */
    this.location = null;
    if (woosmap.position) {
        this.set("location", { lat: woosmap.position.lat, lng: woosmap.position.lng, source: woosmap.position.source });
    } else {
        this.set("location", { lat: undefined, lng: undefined, source: undefined });
    }
};

LocationProvider.TYPE_IP = "ip";
LocationProvider.TYPE_HTML5 = "html5";

LocationProvider.prototype = new MVCObject();

/**
 * Type for Geolocation API
 * @external GeolocationProvider
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Geolocation
 */

/**
 * Set user location given provider.
 * @param {GeolocationProvider|undefined} geoLocationProvider if provider is undefined or if user refuse geolocation then ip location is used
 * @param {function(GeolocationPositionError)} [onError] notified after the IP fallback is applied, so callers can surface the failure
 */
LocationProvider.prototype.askForLocation = function (geoLocationProvider, onError) {
    if (geoLocationProvider) {
        geoLocationProvider.getCurrentPosition(
            function (position) {
                this.set("location", {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    source: LocationProvider.TYPE_HTML5,
                });
                woosmap.finestPosition = { lat: position.coords.latitude, lng: position.coords.longitude };
            }.bind(this),
            function (error) {
                if (woosmap.position) {
                    this.set("location", {
                        lat: woosmap.position.lat,
                        lng: woosmap.position.lng,
                        source: woosmap.position.source,
                    });
                }
                if (onError) onError(error);
            }.bind(this),
        );
    } else {
        if (woosmap.position)
            this.set("location", {
                lat: woosmap.position.lat,
                lng: woosmap.position.lng,
                source: woosmap.position.source,
            });
    }
};

exports.LocationProvider = LocationProvider;
